import { NotFoundPage } from "@app/modules/not-found/pages";

export default function NotFound() {
  return <NotFoundPage />;
}
